import styled, { css } from 'styled-components'

export type MdCaseBadgeTone =
  | 'default'
  | 'danger'
  | 'warning'
  | 'success'
  | 'accent'
  | 'muted'

const toneStyles: Record<MdCaseBadgeTone, ReturnType<typeof css>> = {
  danger: css`
    border-color: ${({ theme }) => `${theme.forecast.danger}80`};
    background: ${({ theme }) => `${theme.forecast.danger}18`};
    color: ${({ theme }) => theme.forecast.defaultText};
  `,
  warning: css`
    border-color: ${({ theme }) => `${theme.forecast.warning}80`};
    background: ${({ theme }) => `${theme.forecast.warning}18`};
    color: ${({ theme }) => theme.forecast.defaultText};
  `,
  success: css`
    border-color: ${({ theme }) => `${theme.forecast.greenGlassBackground}aa`};
    background: ${({ theme }) => theme.forecast.greenGlassBackground};
    color: ${({ theme }) => theme.forecast.defaultText};
  `,
  accent: css`
    border-color: ${({ theme }) => `${theme.forecast.primary}80`};
    background: ${({ theme }) => `${theme.forecast.primary}1e`};
    color: ${({ theme }) => theme.forecast.defaultText};
  `,
  muted: css`
    border-color: ${({ theme }) => theme.forecast.glassBackground};
    background: ${({ theme }) => theme.forecast.defaultGhostButton};
    color: ${({ theme }) => theme.forecast.secondaryText};
  `,
  default: css`
    border-color: ${({ theme }) => theme.forecast.glassBackground};
    background: ${({ theme }) => theme.forecast.defaultGhostButton};
    color: ${({ theme }) => theme.forecast.defaultText};
  `,
}

export { toneStyles as mdCaseToneStyles }

export const MdCaseBadge = styled.span<{ $tone?: MdCaseBadgeTone }>`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.25rem 0.6rem;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
  ${({ $tone = 'default' }) => toneStyles[$tone]}
`
